module.exports = __webpack_public_path__ + "img/김규년 아티스트.2a9a2e18.jpg";